import { forwardRef, Fragment } from 'react';
import {
  AllocatePackIcon,
  BlockIcon,
  CallIcon,
  ChangeStatusIcon,
  DownlaodFileIcon,
  DownlaodIcon,
  EditIcon,
  EyeIcon,
  InvoiceDownloadIcon,
  PasswordIcon,
  PlusIcon,
  RefreshIcon,
  SendIcon,
  TickCircleIcon,
  TrashIcon,
} from '../../helpers/icons';
import { Button } from '../Button';
import { Spinner } from '../Loaders';

const actionsIcon = {
  edit: (
    <div className="d--flex text--info">
      <EditIcon width={16} />
    </div>
  ),
  delete: (
    <div className="d--flex text--danger">
      <TrashIcon width={16} />
    </div>
  ),
  add: (
    <div className="d--flex text--primary">
      <PlusIcon width={16} />
    </div>
  ),
  view: (
    <div className="d--flex text--black">
      <EyeIcon width={16} />
    </div>
  ),
  download: (
    <div className="d--flex text--info">
      <DownlaodIcon width={16} />
    </div>
  ),
  downloadFile: (
    <div className="d--flex text--info">
      <DownlaodFileIcon width={16} />
    </div>
  ),
  status: (
    <div className="d--flex text--primary">
      <ChangeStatusIcon width={16} />
    </div>
  ),
  contact: (
    <div className="d--flex text--success">
      <CallIcon width={16} />
    </div>
  ),
  package: (
    <div className="d--flex text--black">
      <AllocatePackIcon width={16} />
    </div>
  ),
  suspend: (
    <div className="d--flex text--danger">
      <BlockIcon width={14} />
    </div>
  ),
  password: (
    <div className="d--flex text--success">
      <PasswordIcon width={14} />
    </div>
  ),
  refresh: (
    <div className="d--flex text--success">
      <RefreshIcon width={14} />
    </div>
  ),
  send: (
    <div className="d--flex text--success">
      <SendIcon width={14} />
    </div>
  ),
  'download-invoice': (
    <div className="d--flex text--danger">
      <InvoiceDownloadIcon width={16} height={16} />
    </div>
  ),
  convert: (
    <div className="d--flex text--primary">
      <TickCircleIcon width={16} />
    </div>
  ),
  'already-customer': (
    <div className="d--flex text--success">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2.75c.32 0 .63.07.9.21l6.05 3.1c.52.27.85.81.85 1.4v8.08c0 .59-.33 1.13-.85 1.4l-6.05 3.1a1.75 1.75 0 0 1-1.8 0l-6.05-3.1a1.55 1.55 0 0 1-.85-1.4V7.46c0-.59.33-1.13.85-1.4l6.05-3.1c.27-.14.58-.21.9-.21Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="9" r="3.25" stroke="currentColor" strokeWidth="1.4" />
        <path
          d="M7.5 16.25c0-1.8 9-1.8 9 0"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <circle cx="17.75" cy="17.75" r="2.75" fill="#4CAF50" />
        <path
          d="m16.5 17.75 1.1 1.1 2-2.35"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  ),
  activate: (
    <div className="d--flex text--primary">
      <TickCircleIcon color={"green"} width={16} />
    </div>
  ),
};

export const TableActions = ({ rowData, actions = [] }) => {
  return (
    <div className="d--flex align-items--center justify-content--end">
      {actions &&
        actions?.length > 0 &&
        actions.map(
          (
            {
              id = '',
              cb = () => {},
              access = () => true,
              icon,
              disabled = () => false,
              title = '',
              text = () => '',
              isDownloading = () => false,
              showDash = false,
            },
            index,
          ) => {
            if (!access(rowData))
              return <Fragment key={index}>{showDash ? '---' : ''}</Fragment>;
            const isDisabled = disabled(rowData);
            const tooltipText = text(rowData);
            return (
              <div
                className={`${isDisabled ? 'c--not-allowed o--sm' : 'c--pointer'} z-index--xs w-min--28 h-min--28 w-max--28 h-max--28 d--flex align-items--center justify-content--center text--primary radius--sm`}
                onClick={() => !isDisabled && cb(rowData)}
                key={index}
                data-link-hover-black-100
                data-tooltip={tooltipText || title}
                tooltip-position="left"
                // title={isDisabled ? "You can't delete" : title}
              >
                {isDownloading(rowData) ? (
                  <Spinner />
                ) : (
                  (actionsIcon[id] ?? icon)
                )}
              </div>
            );
          },
        )}
    </div>
  );
};

export const TableButton = ({
  text = '',
  icon,
  onClick = () => {},
  variant = 'primary',
  btnClasses = 'btn w-max--150 gap--xs white-space--nowrap',
  color = 'white',
  disabled = false,
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      btnClasses={btnClasses}
      icon={icon}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export const RefetchButton = forwardRef((_, ref) => {
  return (
    <div
      className="d-flex btn_box--sm align-items-center justify-content-center border border--grey radius-6 svg svg--md pointer bg bg--grey"
      onClick={() => ref.current?.refresh()}
    >
      Refetch Icon will be here
    </div>
  );
});

export const FilterButton = forwardRef((_, _ref) => {
  return (
    <div className="d-flex btn_box--sm align-items-center justify-content-center border border--grey radius-6 svg svg--md pointer bg bg--grey">
      Filter Icon will be here
    </div>
  );
});

export const tableSelectionColumn = () => ({
  accessorKey: 'select',
  header: ({ table }) => (
    <input
      type="checkbox"
      className="form--control no--focus"
      checked={table.getIsAllRowsSelected() || table.getIsAllPageRowsSelected()}
      onChange={table.getToggleAllPageRowsSelectedHandler()}
    />
  ),
  cell: ({ row }) => (
    <input
      type="checkbox"
      className="form--control no--focus"
      checked={row.getIsSelected()}
      onChange={row.getToggleSelectedHandler()}
    />
  ),
});

export const TableCellCheck = ({ isCheck }) => {
  return isCheck ? <TickCircleIcon width={20} /> : '---';
};
